import React from 'react';
import PropTypes from 'prop-types';
import TreeFilter from './TreeFilter';
import styles from './TreeFilterList.module.less';
import clsx from 'clsx';

const TreeFilterList = ({
  filtersArray = [],
  onClick,
  topLevel = false,
  group,
  contentRequestInProcess,
  isFilterExpanded,
  showLessAttributes,
}) => {
  return (
    <ul className={clsx(styles.filters, topLevel && styles.topLevel)}>
      {filtersArray
        .filter(filter => filter.count > 0)
        .map((filter, index) => (
          <TreeFilter
            key={filter.name}
            displayName={filter.name}
            urlName={filter.urlSlice}
            count={filter.count}
            href={filter.href}
            selected={filter.selected}
            expand={isFilterExpanded && (!showLessAttributes || index < 5)}
            onClick={onClick}
            group={group}
            contentRequestInProcess={contentRequestInProcess}
          />
        ))}
    </ul>
  );
};

export default TreeFilterList;

TreeFilterList.propTypes = {
  filtersArray: PropTypes.array,
  onClick: PropTypes.func,
  topLevel: PropTypes.bool,
  group: PropTypes.string,
  contentRequestInProcess: PropTypes.bool.isRequired,
  isFilterExpanded: PropTypes.bool.isRequired,
  showLessAttributes: PropTypes.bool.isRequired,
};
